import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useBooking } from '../context/BookingContext';

const Hero = () => {
  const { openBooking } = useBooking();
  return (
    <section id="hero" className="relative h-screen min-h-[700px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/hero-diverse.png"
          alt="Akira Signature Care — A diverse community of confident, radiant patients"
          className="w-full h-full object-cover object-center"
        />
        {/* Base darken */}
        <div className="absolute inset-0 bg-black/35" />
        {/* Strong left-to-right scrim so the text column stays legible while faces remain radiant */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/50 to-transparent" />
        {/* Subtle bottom fade for the CTAs */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-center h-full max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-2xl">
          {/* Headline */}
          <h1
            className="text-white leading-tight mb-6"
            style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 'clamp(2.5rem, 6vw, 5rem)',
              lineHeight: '1.1',
              textShadow: '0 2px 24px rgba(0,0,0,0.45)',
            }}
          >
            Advanced Aesthetics<br />
            <span className="italic text-rose-200">& Precision Health</span>
          </h1>

          {/* Subhead — location & lead physician */}
          <p
            className="text-rose-200 text-sm tracking-[0.25em] uppercase mb-6"
            style={{ textShadow: '0 1px 12px rgba(0,0,0,0.55)' }}
            data-testid="hero-subhead"
          >
            Physician-led medical spa in Alhambra · Angela Trias, M.D.
          </p>

          {/* Subtext */}
          <p
            className="text-white/90 text-lg font-light mb-10 max-w-lg leading-relaxed"
            style={{ textShadow: '0 1px 12px rgba(0,0,0,0.55)' }}
          >
            FDA-cleared skin tightening, non-surgical lifting, injectables,
            and personalized longevity programs — all under one roof.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => openBooking()}
              className="group bg-rose-400 hover:bg-rose-500 text-white text-sm tracking-[0.2em] uppercase px-10 py-4 transition-all duration-300 flex items-center gap-2"
            >
              Book Your Visit
              <span className="group-hover:translate-x-1 transition-transform duration-300 inline-block">→</span>
            </button>
            <Link
              to="/services"
              className="border border-white/60 hover:border-white text-white text-sm tracking-[0.2em] uppercase px-10 py-4 transition-all duration-300 hover:bg-white/10"
            >
              Our Services
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={() => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' })}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/60 hover:text-white transition-colors duration-300"
      >
        <span className="text-xs tracking-widest uppercase">Explore</span>
        <ChevronDown className="w-4 h-4 animate-bounce" />
      </button>
    </section>
  );
};

export default Hero;
